import { pxToRem } from 'styles/functions'

const Theme = {
  body_background_color: 'black',
  card_background_color: 'black',
  logo_image_url: 'awrs.png',
  logo_height: 140,

  token_hidden: true,
  number_hidden: true,

  font_color: 'white',
  text_color: 'white',
  title_color: 'white',
  subtitle_color: 'white',
  button_half_text_color: 'white',
  footer_text_color: 'white',
  photobooth_title_color: 'white',
  input_text_color: 'white',
  input_label_color: 'white',

  legend_color: 'white',
  button_color: '#f5b642',

  button_border_width: 2,

  text_font: `'Arial', sans-serif`,

  title_font: `'Arial', sans-serif`,

  separator_color: '#f5b642',
}

export default Theme
